import { create } from "zustand";

interface ReportDownloadState {
  reportRequestIds: Set<number>;
  setReportRequestIds: (reportRequestIds: Set<number>) => void;
}

export const useReportDownloadStore = create<ReportDownloadState>()(set => ({
  reportRequestIds: new Set(),
  setReportRequestIds: (reportRequestIds: Set<number>) => set({ reportRequestIds }),
}));
